import { StepType } from '../../../../csv-import/data/types/step-type';
import { ConfigStepBody } from './config-step-body';
import { OrderConfigStepFooter } from './config-step-footer';
import { messages } from './messages';

export const ConfigStep = {
  id: StepType.CREATE_CONFIG,
  title: messages.uploadFileStepText,
  body: <ConfigStepBody />,
  footer: <OrderConfigStepFooter />,
};
